var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSidebar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2.25C1.34315 2.25 0 3.59315 0 5.25V18.75C0 20.4069 1.34315 21.75 3 21.75H21C22.6569 21.75 24 20.4069 24 18.75V5.25C24 3.59315 22.6569 2.25 21 2.25H3ZM3 3.75C2.17157 3.75 1.5 4.42157 1.5 5.25V18.75C1.5 19.5784 2.17157 20.25 3 20.25H21C21.8284 20.25 22.5 19.5784 22.5 18.75V5.25C22.5 4.42157 21.8284 3.75 21 3.75H3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.75H10.5V20.25H9V3.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.55C3 5.38431 3.13431 5.25 3.3 5.25H7.2C7.36569 5.25 7.5 5.38431 7.5 5.55V6.45C7.5 6.61569 7.36569 6.75 7.2 6.75H3.3C3.13431 6.75 3 6.61569 3 6.45V5.55Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.55C3 8.38431 3.13431 8.25 3.3 8.25H7.2C7.36569 8.25 7.5 8.38431 7.5 8.55V9.45C7.5 9.61569 7.36569 9.75 7.2 9.75H3.3C3.13431 9.75 3 9.61569 3 9.45V8.55Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.55C3 11.3843 3.13431 11.25 3.3 11.25H7.2C7.36569 11.25 7.5 11.3843 7.5 11.55V12.45C7.5 12.6157 7.36569 12.75 7.2 12.75H3.3C3.13431 12.75 3 12.6157 3 12.45V11.55Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.55C3 14.3843 3.13431 14.25 3.3 14.25H7.2C7.36569 14.25 7.5 14.3843 7.5 14.55V15.45C7.5 15.6157 7.36569 15.75 7.2 15.75H3.3C3.13431 15.75 3 15.6157 3 15.45V14.55Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17.55C3 17.3843 3.13431 17.25 3.3 17.25H7.2C7.36569 17.25 7.5 17.3843 7.5 17.55V18.45C7.5 18.6157 7.36569 18.75 7.2 18.75H3.3C3.13431 18.75 3 18.6157 3 18.45V17.55Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSidebar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sidebar.278f529af96494d370be6be17eb30703.svg";